var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contributions.length)?_c('div',{staticClass:"percentage-container"},_vm._l((_vm.contributions),function(contribution){return _c('div',{key:contribution.id,staticClass:"single-value",style:(_vm.getStyle(contribution))})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }